import CreateOrganizationCard from '@/organizations/views/create-organization/CreateOrganizationCard'

/**
 * Create organization section (individual accounts): the existing CreateOrganizationCard, rendered
 * flat. The card supplies its own "Create an organization" heading + subtitle, so this panel does not
 * add a SettingsPanelShell title (which would double the header). On success the card navigates to
 * the matters dashboard with organizationRosterLocationState in location state; SidebarAccountMenu
 * detects this and switches the already-open settings modal to the Members section.
 */
export function CreateOrganizationPanel() {
  return <CreateOrganizationCard embedded />
}
